import { FC } from 'react';

import { IMAGES_PATH } from '@telialt/assets/src/constants';
import { VariantMatrix } from '@telialt/models/src/EshopModel';

import { CitySearch } from './CitySearch';
import { MapContainer } from './Map/Map.styles';
import { ItemsContainer, RetailsWrapper } from './Retails.styles';
import { RetailsPlaceholderContextProvider } from './RetailsContext';
import { VariantSelector } from './VariantSelector';
import { WeekendFilter } from './WeekendFilter';

type Props = { baseProductCode: string; variantMatrix: VariantMatrix[] };

export const RetailsPlaceholder: FC<Props> = ({ baseProductCode, variantMatrix }) => {
    return (
        <RetailsWrapper aria-hidden={true}>
            <ItemsContainer $gridArea="map">
                <MapContainer>
                    <img src={`${IMAGES_PATH}/lt-map.png`} width="100%" />
                </MapContainer>
            </ItemsContainer>
            <ItemsContainer $gridArea="above">
                <RetailsPlaceholderContextProvider baseProductCode={baseProductCode} variantMatrix={variantMatrix}>
                    <CitySearch />
                    <WeekendFilter />
                    <VariantSelector />
                </RetailsPlaceholderContextProvider>
            </ItemsContainer>
        </RetailsWrapper>
    );
};
